// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2lgeV","containerItemsCenter":"Skeleton_containerItemsCenter__3mg3v"};